module.exports = __webpack_public_path__ + "assets/img/img24.2828f2af.png";